export const originPlaceUrl =
    "https://www.google.com/maps/place/Jelena's+Cake/@51.5107183,0.0105932,17z/data=!4m6!3m5!1s0x47d8a5cfb5421dbb:0x42238edb99a9c277!8m2!3d51.5107762!4d0.0116874!16s%2Fg%2F11jz3p94n0?entry=ttu&g_ep=EgoyMDI1MDMwMi4wIKXMDSoASAFQAw%3D%3D"
